import {
  Info,
  Phone,
  Briefcase,
  Wrench,
  ClipboardList,
  Languages,
  FileText,
  Image,
  StickyNote,
  DollarSign,
  CalendarDays,
  GitBranch,
  MessageSquare,
  Bot,
  Send,
  BookOpen,
  CheckSquare,
  CreditCard,
  Clock,
  Globe,
} from 'lucide-react';

const talentPermission = (resource, action) => ['talent-service', resource, action];

export const TALENT_DETAIL_SECTIONS = Object.freeze([
  { id: 'overview', label: 'Basic Info', icon: Info },
  { id: 'contacts', label: 'Contacts', icon: Phone, subResource: 'contacts' },
  { id: 'professions', label: 'Professions', icon: Briefcase, subResource: 'professions' },
  { id: 'tools', label: 'Tools & Skills', icon: Wrench, subResource: 'tools' },
  { id: 'responsibilities', label: 'Responsibilities', icon: ClipboardList, subResource: 'responsibilities' },
  { id: 'languages', label: 'Languages', icon: Languages, subResource: 'languages' },
  { id: 'cvs', label: 'CVs', icon: FileText, subResource: 'cv' },
  { id: 'media', label: 'Media', icon: Image, subResource: 'media' },
  { id: 'notes', label: 'Notes', icon: StickyNote, subResource: 'notes' },
  { id: 'salary', label: 'Salary', icon: DollarSign, subResource: 'salary' },
  { id: 'important-dates', label: 'Dates', icon: CalendarDays, subResource: 'important_dates' },
  { id: 'stages', label: 'Stages', icon: GitBranch, requiresPermission: talentPermission('playbook_instance', 'list') },
  { id: 'communications', label: 'Communications', icon: MessageSquare, subResource: 'communication' },
  { id: 'ai-settings', label: 'AI Settings', icon: Bot, subResource: 'ai_settings' },
  { id: 'posts', label: 'Posts', icon: Send, requiresPermission: talentPermission('talent_post', 'list') },
  { id: 'courses', label: 'Courses', icon: BookOpen },
  { id: 'tasks', label: 'Tasks', icon: CheckSquare },
  { id: 'accounts', label: 'Accounts', icon: CreditCard, subResources: ['assigned_accounts', 'owner_accounts', 'assigned_social_accounts', 'assigned_credentials'] },
  { id: 'history', label: 'History', icon: Clock, subResource: 'events' },
  { id: 'public-profile', label: 'Public Profile', icon: Globe, subResource: 'public_profile' },
]);
